import { clsx } from 'clsx';
import { Logo } from '../logo';
import { LogoDark } from '../logoDark';
import { HeaderProps } from './header.props';
import styles from './styles.module.scss';

export const Header = ({
  logoTitle,
  logoHref,
  darkSkin = false,
  actions = [],
  env,
}: HeaderProps) => {
  return (
    <header
      className={clsx(
        styles['spo-header'],
        darkSkin && styles['spo-header-dark'],
      )}
      data-testid={`header${darkSkin ? '-dark' : ''}`}
    >
      <a
        data-testid="header-logo"
        aria-label="logo"
        className={styles['spo-header-logo']}
        href={logoHref}
        title={logoTitle}
      >
        {darkSkin ? <LogoDark /> : <Logo />}
        {env && (
          <div
            data-testid="env-banner"
            className={clsx(
              styles['spo-env-banner'],
              env === 'staging' && styles['spo-staging'],
            )}
          >
            {env}
          </div>
        )}
      </a>
      <h2 className={styles['spo-header-title']}>{logoTitle}</h2>
      {!darkSkin && (
        <div className={styles['spo-header-config']}>
          {actions?.map((action) => action)}
        </div>
      )}
    </header>
  );
};
